// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchPanel_wrapper_3zvaJ","title":"SearchPanel_title_zyGKz"};